import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import "./popUp.css"
import { IconButton } from '@mui/material';
import TextField from '@mui/material/TextField';
import LoginForm from '../loginForm/LoginForm';



export default function PopUp({titleStyle={},PopUpStyle={}, open, onClose=null, children, title=null, PopUpButtom, size="sm", showFooter}) {
  

  const handleClose = () => {
    onClose && onClose()
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={size}
        open={open}
        onClose={handleClose}
        sx={{...PopUpStyle}}
      >
        {title && <DialogTitle sx={{...titleStyle}}>{title}</DialogTitle>}
        {onClose && 
        <IconButton
          aria-label="close"
          onClick={handleClose} 
          sx={{
            position: 'absolute',
            right: "8px",
            top: "8px",
            color: "#444",
            cursor: "pointer",
            zIndex:100
          }}
        ><span class="material-symbols-outlined">
cancel
</span></IconButton>
}
        <DialogContent style={{...PopUpStyle, background: ""}}>
        {children}
          
        </DialogContent>
        {showFooter && <DialogActions className='popup_footer'>
          Need an account? <Button className=''>Enroll Now</Button>
        </DialogActions>}
      </Dialog>
    </React.Fragment>
  );
}